import type { ReactNode } from 'react';
import { NetworkingSwitchedOff } from './components';
import { useNetworking } from './shared';

/** `/networks…` exist only while networking is on; else the switched-off text (spec 11 6.15.1). */
export function NetworkingGate({ children }: { children: ReactNode }) {
  const { enabled } = useNetworking();
  return enabled ? <>{children}</> : <NetworkingSwitchedOff />;
}
